import { render } from "./FornecedorForm.vue?vue&type=template&id=6ced68b3"
import script from "./FornecedorForm.vue?vue&type=script&lang=js"
export * from "./FornecedorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__